import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaEdit } from "react-icons/fa";
import { FaEye, FaPlus } from "react-icons/fa";

import {
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Tooltip,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

const CustomerView = () => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const location = useLocation();
  const customerType = location.state?.customerType;

  const [tableRows, setTableRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const receiptsPerPage = 10;
  const limit = 50;
  const [isLoading, setIsLoading] = useState(true);

  const totalPages = Math.ceil(filteredRows.length / receiptsPerPage);
  const navigate = useNavigate();

  const paginate = (pageNumber) => {
    if (pageNumber >= 1) setCurrentPage(pageNumber);
  };

  const onEdit = (accountNoEditObject) => {
    const { accountNo, openDocumentTab, accountName } = accountNoEditObject;
    navigate("/customerCreation", {
      state: {
        tabIndex: openDocumentTab ? 0 : 0,
        editAccNo: accountNo,
        custName: accountName,
      },
    });
  };

  const onBack = () => navigate("/customerCreation");

  const fetchDocumentTableCustomer = async (page = 1, search) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    let apiURL = "";

    if (customerType === "Supplier") {
      apiURL = `${
        apiPaths[0]?.API_CONFIG
      }/api/CRMAccountListPage/${COMPANY_CODE}/ACCOUNTLIST/${department}/SUPPLIERS/-/${
        search || "-"
      }/${page}/${limit}`;
    } else {
      apiURL = `${
        apiPaths[0]?.API_CONFIG
      }/api/CRMAccountListPage/${COMPANY_CODE}/ACCOUNTLIST/${department}/CUSTOMERS/-/${
        search || "-"
      }/${page}/${limit}`;
    }

    try {
      const response = await axios.get(apiURL);
      setTableRows(response.data || []);
      setFilteredRows(response.data || []); // ✅ Set filtered rows initially
    } catch (err) {
      console.error("Error while fetchDocumentTableCustomer", err);
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchDocumentTableCustomer(currentPage , searchTerm);
  // }, [currentPage, customerType , searchTerm]);

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchDocumentTableCustomer(currentPage, searchTerm);
    }, 100);

    return () => clearTimeout(delay);
  }, [searchTerm, customerType, currentPage]);

  // ✅ Filter table when searchTerm changes
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredRows(tableRows);
    } else {
      const filtered = tableRows.filter(
        (rec) =>
          rec.ACCOUNT?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          rec.DESCRIPTION?.toLowerCase().includes(searchTerm.toLowerCase()),
      );
      setFilteredRows(filtered);
    }
  }, [searchTerm, tableRows]);

  const onCustomerCreation = () => {
    navigate(`/customerCreation`);
    // window.location.reload(); // forces full refresh
  };

  return (
    <div className="mx-2">
      <div className="flex flex-wrap items-center justify-between gap-16 mt-2">
        <div className="flex gap-12 justify-between items-center ">
          <h2 className="text-lg text-gray-800 ">Customer View</h2>

          {/* <RadioGroup
            row
            name="customerType"
            value={customerType}
            disabled
            className="flex items-center"
          >
            <FormControlLabel
              value="Customer"
              control={<Radio size="small" color="default" />}
              label="Customer"
            />
            <FormControlLabel
              value="Supplier"
              control={<Radio size="small" color="default" />}
              label="Supplier"
            />
          </RadioGroup> */}
        </div>

        <div className="flex justify-end items-center">
          <input
            type="text"
            placeholder="Search by Account or Description"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-[300px]  px-3 py-2 shadow-sm text-sm rounded-md bg-white border border-gray-300 placeholder-gray-400 focus:outline-none focus:border-gray-400"
          />
        </div>

        <div className="">
          {/* Back Button */}
          <button
            onClick={onBack}
            className="hidden relative bg-gray-600 text-white font-medium text-[17px] px-2 py-[0.25em] pl-3 h-[1.8em] rounded-[0.9em] flex items-center overflow-hidden cursor-pointer group"
          >
            <span className="mr-10">Back</span>
            <div className="absolute right-[0.3em] bg-white h-[1.4em] w-[1.4em] rounded-[0.7em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)] active:scale-95">
              <FaArrowLeft className="text-gray-600" />
            </div>
          </button>
          <button
            onClick={onCustomerCreation}
            className="relative ml-4 bg-green-600 text-white font-medium text-[17px] px-2 py-[0.35em]  h-[1.8em] rounded-[0.9em] flex items-center overflow-hidden cursor-pointer   group"
          >
            <span className="mr-8">New</span>
            <div className="absolute right-[0.3em] bg-white h-[1.2em] w-[1.4em] rounded-[0.7em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)]  active:scale-95">
              <FaPlus className=" text-green-600 " />
            </div>
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto mt-4 max-h-[60vh]">
        <table className="min-w-full bg-white border border-gray-200 text-sm shadow-sm">
          <thead className="bg-gray-100 text-sm sticky top-0 z-20 shadow-sm">
            <tr>
              {[
                "Account",
                "Description",
                "Patron Type",
                "Contact No",
                "Sales Person",
                "Balance",
                "Open Balance",
                "Credit Mode",
                "Credit Limit",
                "Due Days",
                "Created On",
                "TRN",
                "Action",
              ].map((header) => (
                <th
                  key={header}
                  className="px-4 py-1 font-semibold text-gray-700 border text-left"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredRows.length > 0 ? (
              filteredRows.map((rec, index) => (
                <tr
                  key={index}
                  className={`hover:bg-blue-50 border ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
                >
                  <td className="px-4 w-30 py-2 border text-xs text-left">
                    {rec.ACCOUNT}
                  </td>
                  <td className="px-4 py-2 w-54  border text-[0.78em] text-left">
                    {rec.DESCRIPTION || "-"}
                  </td>
                  <td className="px-4  w-36  py-2 border text-xs text-left">
                    {rec.Patron_Type || "-"}
                  </td>
                  <td className="px-4 py-2 border text-xs text-right">
                    {rec.Contact_No?.trim() || "-"}
                  </td>
                  <td className="px-4 py-2 w-36  border text-[0.78em] text-left">
                    {rec.Sales_Person || "-"}
                  </td>
                  <td className="px-4 py-2 border text-xs text-right">
                    {rec.BALANCE}
                  </td>
                  <td className="px-4 py-2 border text-xs text-right">
                    {rec.openbal}
                  </td>
                  <td className="px-4 py-2 w-36  border text-xs text-left">
                    {rec.Credit_Mode || "-"}
                  </td>
                  <td className="px-4 py-2 w-28  border text-xs text-right">
                    {rec.Credit_Limit}
                  </td>
                  <td className="px-4 py-2 w-28  border text-xs text-right">
                    {rec.Due_Days}
                  </td>
                  <td className="px-4 py-2  w-28  border text-xs text-center">
                    {rec.Created_On
                      ? dayjs(rec.Created_On).format("DD/MM/YYYY")
                      : "-"}
                  </td>
                  <td className="px-4 py-2 w-28  border text-xs text-right">
                    {rec.trn}
                  </td>
                  <td className="px-2 py-1 border-b text-xs text-gray-600 ">
                    <div className="flex justify-end gap-2">
                      <Tooltip title="Edit Customer" arrow>
                        <button
                          onClick={() =>
                            onEdit({
                              accountNo: rec.ACCOUNT,
                              accountName: rec.DESCRIPTION,
                              openDocumentTab: true,
                            })
                          }
                          className="px-2 py-1 rounded text-white bg-blue-600 flex items-center gap-1 text-xs hover:bg-blue-700"
                        >
                          <FaEdit size={12} /> Edit
                        </button>
                      </Tooltip>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={11} className="text-center py-6 text-gray-500">
                  {isLoading ? "Loading Data..." : "No Matching Records Found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-between bg-gray-100 items-center px-2 py-4 shadow-sm rounded-md mt-2">
        <div className="text-sm text-gray-600">
          Showing page {currentPage} ({filteredRows.length} rows)
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className={`px-3 py-1 text-xs rounded-lg ${
              currentPage === 1
                ? "bg-gray-200 cursor-not-allowed"
                : "bg-blue-600 text-white hover:bg-blue-700"
            }`}
          >
            Previous
          </button>
          {/* <span className="px-3 py-1 text-xs text-gray-700">
            Page {currentPage} of {totalPages}
          </span> */}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages || filteredRows.length === 0}
            className={`px-3 py-1 text-xs rounded-lg ${
              currentPage === totalPages || filteredRows.length === 0
                ? "bg-gray-200 cursor-not-allowed text-gray-500"
                : "bg-blue-600 text-white hover:bg-blue-700"
            }`}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerView;
